import {
  AlquilerBase,
  Boletin,
  CompraBase,
  Espectaculo,
  EspectaculoBase,
  Funcion,
  ICaratulaEspectaculo,
  IFichaEspectaculo,
  Sala,
  Taller,
  TallerBase,
  TallerListado,
  TipoElenco,
  TipoGenerico,
  TipoParametro,
  UsuarioBase,
  UsuarioDTO,
  VentaListado,
} from 'utils/models/types';
import { API_BASE_URL } from './constants';
import { axiosInstance } from './apiUtils';
import axios from 'axios';
import { ListadoCompra } from 'utils/models/interfaces';

// TIPOS Y DATOS
const getTiposElenco = () => getData<TipoElenco[]>(`${API_BASE_URL}/TiposElenco`);
const getTiposRol = () => getData<TipoGenerico[]>(`${API_BASE_URL}/Roles`);
const getTiposSocio = () => getData<TipoGenerico[]>(`${API_BASE_URL}/TiposSocio`);
const getParametroId = (id: string) => getData<TipoParametro>(`${API_BASE_URL}/Parametros/${id}`);
const getParametros = () => getData<[]>(`${API_BASE_URL}/Parametros/ListarParams`);
const getGeneros = () => getData<[]>(`${API_BASE_URL}/Generos`);
const getTipoElencoPorId = () => getData<TipoElenco>(`${API_BASE_URL}/TiposElenco`);
const getGeneroPorId = () => getData<TipoGenerico>(`${API_BASE_URL}/Generos`);
const getTipoSocioPorId = () => getData<TipoGenerico>(`${API_BASE_URL}/TiposSocio`);

//ALQUILERES
const getAlquileres = () => getData<AlquilerBase[]>(`${API_BASE_URL}/Alquileres/ListarAlquileres`);
const getAlquilerById = (id: string) => getData<AlquilerBase>(`${API_BASE_URL}/Alquileres/${id}`);

// TALLERES
const getTalleres = () => getData<TallerListado[]>(`${API_BASE_URL}/Talleres/`);
const getSelectTalleres = () => getData<TipoGenerico[]>(`${API_BASE_URL}/Talleres/select`);
const getGrillaTalleres = () => getData<Taller[]>(`${API_BASE_URL}/Talleres/grid`);
const getTallerById = (id: string) => getData<TallerBase>(`${API_BASE_URL}/Talleres/${id}`);
const getTalleresDeUsuario = (id: string) => getData<TallerBase[]>(`${API_BASE_URL}/Talleres/byUser/${id}`);
const getInscriptosTaller = (id: string) => getData<UsuarioBase[]>(`${API_BASE_URL}/Talleres/inscriptos/${id}`);

// SALAS
const getSalas = () => getData<Sala[]>(`${API_BASE_URL}/Salas/select`);
const getSalaPorId = (id: string) => getData<Sala>(`${API_BASE_URL}/Salas/${id}`);

// USUARIOS
const getUsuarios = () => getData<UsuarioBase[]>(`${API_BASE_URL}/Usuarios/ListarUsuarios`);
const getUsuarioPorId = (id: string) => getData<UsuarioDTO>(`${API_BASE_URL}/Usuarios/${id}`);

// COMPRAS
const getCompras = () => getData<ListadoCompra[]>(`${API_BASE_URL}/CompraEntrada`);
const getVentas = () => getData<VentaListado[]>(`${API_BASE_URL}/CompraEntrada/ventas`);
const getComprasDeUsuario = (id: string) => getData<CompraBase[]>(`${API_BASE_URL}/CompraEntrada/byUser/${id}`);

// ESPECTACULOS
const getGrillaEspectaculos = () => getData<ICaratulaEspectaculo[]>(`${API_BASE_URL}/Espectaculos/grid`);
const getEspectaculos = () => getData<EspectaculoBase[]>(`${API_BASE_URL}/Espectaculos`);
const getEspectaculoById = (id: string) => getData<Espectaculo>(`${API_BASE_URL}/Espectaculos/${id}`);
const getFichaEspectaculoById = (id: string) => getData<IFichaEspectaculo>(`${API_BASE_URL}/Espectaculos/ficha/${id}`);
const getFuncionesPorIdEspectaculo = (id: string) => getData<Funcion[]>(`${API_BASE_URL}/Espectaculos/funciones/${id}`);

// BOLETINES
const getBoletines = () => getData<Boletin[]>(`${API_BASE_URL}/Email/boletines`);

export {
  getSelectTalleres,
  getTiposElenco,
  getTiposRol,
  getTiposSocio,
  getAlquileres,
  getUsuarios,
  getSalas,
  getSalaPorId,
  getEspectaculos,
  getGrillaEspectaculos,
  getAlquilerById,
  getTallerById,
  getEspectaculoById,
  getFichaEspectaculoById,
  getUsuarioPorId,
  getParametros,
  getGeneros,
  getGeneroPorId,
  getTipoSocioPorId,
  getTipoElencoPorId,
  getFuncionesPorIdEspectaculo,
  getTalleres,
  getGrillaTalleres,
  getTalleresDeUsuario,
  getCompras,
  getComprasDeUsuario,
  getVentas,
  getInscriptosTaller,
  getParametroId,
  getBoletines,
};

// Función genérica GET
export const getData = async <T>(url: string): Promise<T> => {
  try {
    const response = await axiosInstance.get<T>(url);
    return response.data;
  } catch (error: unknown) {
    console.error(`Error obteniendo datos de ${url}:`, error);

    if (axios.isAxiosError(error)) {
      if (error.response) {
        let serverErrorMessage = 'Error desconocido en el servidor';
        if (error.response.data) {
          serverErrorMessage = error.response.data;
        } else if (error.response.status === 401 || error.response.status === 403) {
          serverErrorMessage = 'No tienes permisos para esta operación';
        }
        return Promise.reject(new Error(serverErrorMessage));
      } else if (error.request) {
        // No hubo respuesta
        return Promise.reject(new Error('No hubo respuesta del servidor'));
      } else {
        // Error de request
        return Promise.reject(new Error('Error de solicitud'));
      }
    }
    return Promise.reject(error instanceof Error ? error : new Error(String(error)));
  }
};
